import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=81b87474&scoped=true"
import script from "./customerservice.vue?vue&type=script&lang=js"
export * from "./customerservice.vue?vue&type=script&lang=js"
import style0 from "./customerservice.vue?vue&type=style&index=0&id=81b87474&prod&lang=scss&scoped=true"
import style1 from "./customerservice.vue?vue&type=style&index=1&id=81b87474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b87474",
  null
  
)

export default component.exports